// Detecta frontend novo publicado no container e recarrega o app (inclusive o
// PWA instalado) sem o usuário precisar limpar cache. Compara o main.js carregado
// com o do asset-manifest.json atual do servidor. O reload só acontece em momento
// seguro: janela em segundo plano ou troca de rota, nunca com campo em edição.
const CHECK_INTERVAL = 5 * 60 * 1000;
const RELOAD_FLAG = "appUpdateReloadAt";

let updateAvailable = false;

const currentMainScript = () => {
  const script = document.querySelector('script[src*="/static/js/main."]');
  return script ? new URL(script.src, window.location.origin).pathname : null;
};

const isEditing = () => {
  const el = document.activeElement;
  if (!el) return false;
  return (
    el.tagName === "INPUT" ||
    el.tagName === "TEXTAREA" ||
    el.tagName === "SELECT" ||
    el.isContentEditable
  );
};

const reload = () => {
  // Evita loop se o servidor ainda estiver servindo o index antigo
  const lastReload = Number(sessionStorage.getItem(RELOAD_FLAG) || 0);
  if (Date.now() - lastReload < 60000) return;
  sessionStorage.setItem(RELOAD_FLAG, String(Date.now()));
  window.location.reload();
};

const reloadIfSafe = ({ routeChange = false } = {}) => {
  if (!updateAvailable) return;
  if (document.hidden || (routeChange && !isEditing())) reload();
};

const checkForUpdate = async () => {
  if (updateAvailable || !navigator.onLine) return;
  const loaded = currentMainScript();
  if (!loaded) return;

  try {
    const response = await fetch(`${process.env.PUBLIC_URL}/asset-manifest.json`, {
      cache: "no-store",
    });
    if (!response.ok) return;
    const manifest = await response.json();
    const latest = manifest?.files?.["main.js"];
    if (latest && new URL(latest, window.location.origin).pathname !== loaded) {
      updateAvailable = true;
      reloadIfSafe();
    }
  } catch (_) {
    // Servidor fora do ar durante o deploy: tenta na próxima checagem
  }
};

export const startAppUpdater = (history) => {
  if (process.env.NODE_ENV !== "production") return;

  setInterval(checkForUpdate, CHECK_INTERVAL);
  window.addEventListener("online", checkForUpdate);
  document.addEventListener("visibilitychange", () => {
    if (document.hidden) reloadIfSafe();
    else checkForUpdate();
  });
  history.listen(() => reloadIfSafe({ routeChange: true }));
};
